import classNames from 'classnames';

import './spinner.scss';
import spinnerSVG from './spinner.svg';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const Spinner = ({ size }: SpinnerProps) => {
  return (
    <span className={classNames('payflow-ui payflow-spinner', size && `payflow-spinner__size-${size}`)}>
      <img src={spinnerSVG} alt="loading" aria-hidden />
    </span>
  );
};
